module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Reģistrācija")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "ui negative icon message"
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Lūdzu aizpildi visus laukus:\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.error), function(item) {
    return _c('li', [_vm._v(_vm._s(item[0]))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Klienta veids")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.person_type),
      expression: "userObj.person_type"
    }],
    staticClass: "ui fluid dropdown",
    attrs: {
      "id": "person_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userObj, "person_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userType), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), (_vm.userObj.person_type == 1) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Personas kods")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.legalid),
      expression: "userObj.legalid"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Personas kods, piemēram, 111111-11111",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.userObj.legalid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "legalid", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Reģistrācijas nr.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.legalid),
      expression: "userObj.legalid"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Reģistrācijas nr., piemēram, 40000000000",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.userObj.legalid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "legalid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [(_vm.userObj.person_type == 1) ? _c('label', [_vm._v("Vārds")]) : _c('label', [_vm._v("Nosaukums")]), _vm._v(" "), (_vm.userObj.person_type == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_surname1),
      expression: "name_surname1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Vārds"
    },
    domProps: {
      "value": (_vm.name_surname1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_surname1 = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_surname1),
      expression: "name_surname1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nosaukums"
    },
    domProps: {
      "value": (_vm.name_surname1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_surname1 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.userObj.person_type == 1) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Uzvārds")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_surname2),
      expression: "name_surname2"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Uzvārds"
    },
    domProps: {
      "value": (_vm.name_surname2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_surname2 = $event.target.value
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("E-pasts")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.email),
      expression: "userObj.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "E-pasts"
    },
    domProps: {
      "value": (_vm.userObj.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Tālrunis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.phone),
      expression: "userObj.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tālrunis"
    },
    domProps: {
      "value": (_vm.userObj.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Parole")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.password),
      expression: "userObj.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Parole - vismaz 8 simboli"
    },
    domProps: {
      "value": (_vm.userObj.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Parole atkārtoti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.password2),
      expression: "userObj.password2"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Parole atkārtoti"
    },
    domProps: {
      "value": (_vm.userObj.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userObj, "password2", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Kur Jūs par mums uzzinājāt?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.reference),
      expression: "userObj.reference"
    }],
    staticClass: "ui fluid dropdown",
    attrs: {
      "id": "person_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userObj, "reference", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.reference), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.userObj.address), function(addressItem) {
    return [_c('div', {
      staticClass: "ui hidden divider"
    }), _vm._v(" "), (addressItem.is_legal_address) ? _c('h4', {
      staticClass: "ui dividing header"
    }, [_vm._v("Juridiskā adrese")]) : _c('h4', {
      staticClass: "ui dividing header"
    }, [_vm._v("Piegādes adrese")]), _vm._v(" "), _c('div', {
      staticClass: "two fields"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Pilsēta")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.city),
        expression: "addressItem.city"
      }],
      staticClass: "ui fluid dropdown",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(addressItem, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.city), function(item) {
      return _c('option', {
        domProps: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.label))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Reģions")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.region),
        expression: "addressItem.region"
      }],
      staticClass: "ui fluid dropdown",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(addressItem, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.filteredRegion), function(item) {
      return (!addressItem.is_legal_address) ? _c('option', {
        domProps: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.label))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.filteredRegionLegal), function(item) {
      return (addressItem.is_legal_address) ? _c('option', {
        domProps: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.label))]) : _vm._e()
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "three fields"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Iela")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.street),
        expression: "addressItem.street"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Iela"
      },
      domProps: {
        "value": (addressItem.street)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addressItem, "street", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Mājas nr. / nosaukums")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.house_no),
        expression: "addressItem.house_no"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Mājas nr. / nosaukums"
      },
      domProps: {
        "value": (addressItem.house_no)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addressItem, "house_no", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Dzīvokļa nr.")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.flat_no),
        expression: "addressItem.flat_no"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Dzīvokļa nr."
      },
      domProps: {
        "value": (addressItem.flat_no)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addressItem, "flat_no", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), (!addressItem.is_legal_address) ? _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "two fields"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Tālrunis")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.phone),
        expression: "addressItem.phone"
      }],
      staticClass: "address-phone",
      attrs: {
        "type": "text",
        "placeholder": "Norādiet tālruni kurjeram"
      },
      domProps: {
        "value": (addressItem.phone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addressItem, "phone", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Piezīmes")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addressItem.notes),
        expression: "addressItem.notes"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Piemēram, durvju kods"
      },
      domProps: {
        "value": (addressItem.notes)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addressItem, "notes", $event.target.value)
        }
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.userObj.person_type > 1 && !addressItem.is_legal_address) ? _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "ui checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.hideLegalAddress),
        expression: "hideLegalAddress"
      }],
      attrs: {
        "id": "newsletter",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.hideLegalAddress) ? _vm._i(_vm.hideLegalAddress, null) > -1 : (_vm.hideLegalAddress)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.hideLegalAddress,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.hideLegalAddress = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.hideLegalAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.hideLegalAddress = $$c
          }
        }, _vm.legalAddressToogle]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "newsletter"
      }
    }, [_vm._v("Piegādes adrese sakrīt ar juridisko")])])]) : _vm._e()]
  }), _vm._v(" "), _c('h4', {
    staticClass: "ui dividing header"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userObj.confirmed_agreement),
      expression: "userObj.confirmed_agreement"
    }],
    attrs: {
      "value": "1",
      "type": "checkbox",
      "number": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.userObj.confirmed_agreement) ? _vm._i(_vm.userObj.confirmed_agreement, "1") > -1 : (_vm.userObj.confirmed_agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.userObj.confirmed_agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.userObj, "confirmed_agreement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.userObj, "confirmed_agreement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.userObj, "confirmed_agreement", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown button",
    class: {
      disabled: !_vm.userObj.confirmed_agreement
    },
    on: {
      "click": _vm.registerUser
    }
  }, [_vm._v("Izveidot profilu")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Esmu izlasījis un piekrītu "), _c('a', {
    attrs: {
      "href": "https://api.memorywater.lv/files/ligums.pdf",
      "target": "_blank"
    }
  }, [_vm._v("līguma noteikumiem.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e00b53e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterUserPage.vue
// module id = 366
// module chunks = 1